module.exports = __webpack_public_path__ + "static/media/arrow-up.44c7e8a1.svg";